import { useMemo } from "react"
import { Go1, Go10, Go12 } from 'assets'

const useAffiliationSetupCards = () => {

    const trainingCards = useMemo(() => [
        {
            id: 1,
            title: "הכנסת פרטי בית הספר",
            description: "מילוי הפרטים יאפשר התאמה מדויקת של המערכת והתחלה קלה ומהירה של העבודה.",
            button: "כניסה למילוי הפרטים",
            img: Go10,
            imgSize: {
                width: 150,
                height: 230
            },
            tabIndex: 0
        },
        {
            id: 2,
            title: "הכנסת התלמידים",
            description: "יש להקפיד על מילוי מלא ומדויק של כל הפרטים הרלוונטיים, כדי להתחיל בביצוע המבדקים.",
            button: "כניסה למילוי הפרטים",
            img: Go1,
            imgSize: {
                width: 180,
                height: 250
            },
            tabIndex: 1
        },
        {
            id: 3,
            title: "הכנסת הצוות",
            description: "מילוי מדויק של פרטי הצוות יאפשר ניהול נכון של המערכת, הקצאת הרשאות מתאימות והתחלה חלקה של העבודה.",
            button: "כניסה למילוי הפרטים",
            img: Go12,
            imgSize: {
                width: 280,
                height: 220
            },
            tabIndex: 2
        }
    ], [])

    return trainingCards
}

export default useAffiliationSetupCards